<div class="wrapper">
  <form [formGroup]="form">
    <div class="two-items">
      <div class="form-component inspection-forms-field">
        <mat-form-field>
          <mat-select formControlName="Layer" matTooltip="{{ 'configurations-fields.tooltips.Layer' | translate }}">
            <mat-option *ngFor="let layer of layers" [value]="layer.Id"> {{ layer.Name }} ({{ layer.Slug }}) </mat-option>
          </mat-select>
          <mat-placeholder>{{
            layers.length ? ("configurationTab.layer" | translate) : ("configurationTab.noLayer" | translate)
          }}</mat-placeholder>
        </mat-form-field>
        <mat-icon class="update-icon" mat-icon-button (click)="updateLayers()">sync</mat-icon>
      </div>

      <div class="form-component main-color">
        <mee-color-picker [position]="ColorPickerPosition.Left" formControlName="MainColor"></mee-color-picker>
      </div>
    </div>

    <!--AltitudeMode (UI name - Elevation Type)-->

    <div class="two-items">
      <div class="form-component" *ngIf="isDisplayForCurrentSourceType(configurationFields.AltitudeMode)">
        <mat-form-field>
          <mat-select matTooltip="{{ 'configurations-fields.tooltips.AltitudeMode' | translate }}" formControlName="AltitudeMode">
            <mat-option *ngFor="let mode of altitudeModesModel" [value]="mode.value">
              {{ mode.title | translate }}
            </mat-option>
          </mat-select>
          <mat-placeholder>{{ "configurations-fields.AltitudeMode" | translate }}</mat-placeholder>
        </mat-form-field>
      </div>

      <div class="form-component with-measurement" *ngIf="isDisplayForCurrentSourceType(configurationFields.VerticalDatum)">
        <mee-vertical-datum formControlName="VerticalDatum"></mee-vertical-datum>

        <mat-form-field matTooltip="{{ 'configurations-fields.tooltips.MeasurementSystem' | translate }}">
          <mat-select placeholder="UoM" formControlName="VerticalMeasurementSystem">
            <mat-option *ngFor="let measurementSystemOption of measurementSystemOptions" [value]="measurementSystemOption.value">
              {{ measurementSystemOption.title }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="one-item" *ngIf="isDisplayForCurrentSourceType(configurationFields.DefaultDepth)">
      <div class="form-component with-measurement">
        <mee-configuration-compound-input-new
          formControlName="DefaultDepth"
          placeholder="{{ 'configurations-fields.DefaultDepth' | translate }}"
          helpTooltip="{{ 'configurations-fields.tooltips.DepthAltitude' | translate }}"
        ></mee-configuration-compound-input-new>
      </div>
    </div>

    <p class="additional-details-title">
      {{ "configurations-fields.AdditionalDetails" | translate }}
    </p>

    <div class="one-item" *ngIf="isDisplayForCurrentSourceType(configurationFields.IsExcludedFromProcessing)">
      <div class="form-component">
        <mat-slide-toggle
          formControlName="IsExcludedFromProcessing"
          matTooltip="{{ 'configurations-fields.tooltips.ExcludeFromProcessing' | translate }}"
          color="primary"
        >
          {{ "configurations-fields.tooltips.ExcludeFromProcessing" | translate }}
        </mat-slide-toggle>
      </div>
    </div>
  </form>
</div>
